import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { getColor } from 'common/constants/_colors';
import _ from 'lodash';

const pulse = color => keyframes`
  0% {
    box-shadow: 0 0 0 0 ${color};
  }
  50% {
    box-shadow: 0 0 4px 1rem ${color}00;
  }
`;

const animation = ({ color, isGlowing }) =>
  isGlowing
    ? css`
        animation: ${pulse(color)} 2s infinite;
      `
    : '';

const RingWithCenteredCircle = styled.div`
  width: 2.36rem;
  height: 2.36rem;
  border: solid 0.2rem ${({ color }) => color};
  border-radius: 50%;
  position: relative;
  ${animation}

  :hover {
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  }

  :before {
    content: '';
    display: block;
    position: absolute;
    width: 1.45rem;
    height: 1.45rem;
    background-color: ${({ color }) => color};
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${({ disabled }) =>
      disabled ? 'box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.25) inset;' : ''}
  }
`;

const GlowingButton = ({
  color = 'chambray',
  isGlowing = false,
  disabled = false,
  onClick = _.noop,
  ...rest
}) => (
  <RingWithCenteredCircle
    onClick={onClick}
    color={getColor(disabled ? 'silverSand' : color)}
    isGlowing={!disabled && isGlowing}
    disabled={disabled}
    {...rest}
  />
);

export default GlowingButton;
